"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2514],{

/***/ 22514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Checkbox": function() { return /* reexport */ Checkbox_Checkbox; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
;// CONCATENATED MODULE: ./src/components/atoms/Checkbox/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  margin-bottom: ",
        ";\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  cursor: pointer;\n  position: relative;\n  margin-left: -4px;\n  margin-top: 1rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  display: flex;\n  cursor: pointer;\n  justify-content: flex-start;\n  align-items: center;\n  padding-right: 1.25rem;\n  input[type="checkbox"] {\n    display: none;\n    position: relative;\n    right: -999em;\n  }\n  div {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 26px;\n\n    span {\n      border: 1px solid ',
        ";\n      width: 14px;\n      height: 14px;\n      display: inline-block;\n    }\n\n    :focus {\n      border-radius: 50%;\n      border: 1px solid;\n      outline: none;\n      border-color: ",
        ";\n      background-color: ",
        ";\n    }\n  }\n\n  input:checked + div {\n    span {\n      background-clip: content-box;\n      padding: 2px;\n      color: ",
        ";\n      background-color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  display: none;\n  cursor: pointer;\n  justify-content: flex-start;\n  align-items: center;\n  padding-right: 1.25rem;\n  input[type="checkbox"] {\n    display: none;\n    position: relative;\n    right: -999em;\n  }\n  div {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 26px;\n\n    span {\n      border: 1px solid ',
        ";\n      width: 14px;\n      height: 14px;\n      display: inline-block;\n    }\n\n    :focus {\n      border-radius: 50%;\n      border: 1px solid;\n      outline: none;\n      border-color: ",
        ";\n      background-color: ",
        ";\n    }\n  }\n\n  input:checked + div {\n    span {\n      background-clip: content-box;\n      padding: 2px;\n      color: ",
        ";\n      background-color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var Checkbox = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject(), function(param) {
    var _marginBottomValue = param.marginBottomValue, marginBottomValue = _marginBottomValue === void 0 ? "1.25rem" : _marginBottomValue;
    return "".concat(marginBottomValue, "rem");
});
var Label = emotion_styled_browser_esm/* default.label */.Z.label(_templateObject1(), function(props) {
    return props.theme.colors.secondary.base;
}, function(props) {
    return props.theme.colors.secondaryOverlayDark;
}, function(props) {
    return props.theme.colors.secondaryOverlayDark;
}, function(props) {
    return props.theme.colors.black;
}, function(props) {
    return props.theme.colors.black;
});
/* Adding 'disabled' to the input doesn't work so had to just hide it instead with display: none */ var LabelHidden = emotion_styled_browser_esm/* default.label */.Z.label(_templateObject2(), function(props) {
    return props.theme.colors.secondary.base;
}, function(props) {
    return props.theme.colors.secondaryOverlayDark;
}, function(props) {
    return props.theme.colors.secondaryOverlayDark;
}, function(props) {
    return props.theme.colors.black;
}, function(props) {
    return props.theme.colors.black;
});

;// CONCATENATED MODULE: ./src/components/atoms/Checkbox/Checkbox.tsx
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */ 





var ENTER_KEY = 13;
var SPACE_KEY = 32;
var Checkbox_Checkbox = function(_param) {
    var name = _param.name, checked = _param.checked, _onChange = _param.onChange, onChange = _onChange === void 0 ? function() {
        return null;
    } : _onChange, children = _param.children, dataTest = _param.dataTest, disabled = _param.disabled, marginBottomValue = _param.marginBottomValue, props = (0,_object_without_properties/* default */.Z)(_param, [
        "name",
        "checked",
        "onChange",
        "children",
        "dataTest",
        "disabled",
        "marginBottomValue"
    ]);
    var ref = react.useRef(null);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Checkbox, {
        marginBottomValue: marginBottomValue,
        ref: ref,
        onClick: function(evt) {
            evt.preventDefault();
            onChange(evt);
            if (ref.current) {
                ref.current.blur();
            }
        },
        "data-test": dataTest,
        children: [
            !disabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Label, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                        tabIndex: -1,
                        type: "checkbox",
                        name: name,
                        checked: checked,
                        readOnly: true
                    })),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        ref: ref,
                        tabIndex: 0,
                        onKeyDown: function(evt) {
                            if (evt.which === SPACE_KEY || evt.which === ENTER_KEY) {
                                evt.preventDefault();
                                onChange(evt);
                            }
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {})
                    })
                ]
            }),
            disabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LabelHidden, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                        tabIndex: -1,
                        type: "checkbox",
                        name: name,
                        checked: checked,
                        readOnly: true,
                        disabled: disabled
                    })),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        ref: ref,
                        tabIndex: 0,
                        onKeyDown: function(evt) {
                            if (evt.which === SPACE_KEY || evt.which === ENTER_KEY) {
                                evt.preventDefault();
                                onChange(evt);
                            }
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {})
                    })
                ]
            }),
            children
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/atoms/Checkbox/index.ts



/***/ }),

/***/ 99534:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ })

}]);